import { Backdrop, Fade, makeStyles } from "@material-ui/core";
import React, {
  Fragment,
  useImperativeHandle,
  forwardRef,
  useState,
  useRef,
} from "react";
import Modal from "@material-ui/core/Modal";
import { useTranslation } from "react-i18next";
import Btn from "../../components/Button/Button";
import Input from "../../components/Input/Input";
import { useForm } from "react-hook-form";
import { ValidationService } from "../../utils/Validation";
import useToast from "../../components/Toast/hooks/useToast";
import { useAppContext } from "../../AppContext/App.context";
import useApiService from "../../services/api.service";
import { extensionService } from "./Extensions.endpoints";
import useLoader from "../../hooks/useLoader";
import Phone from "../../components/phone-picker/phone-picker";
const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  textField: {
    marginTop: "4px!important",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 7, 3),
    width: "500px",
    outline: "none",
  },
  btn: {
    margin: theme.spacing(2),
  },
  dropdown: {
    textAlign: "left",
    marginBottom: "-15px!important",
  },
}));
let extensionPrice: any = 0;
const SosConfiguration = forwardRef((props: any, ref: any) => {
  extensionPrice = props.price;
  const { t, i18n } = useTranslation(["Extension"]);
  const [open, setOpen] = React.useState(false);
  const [operation, setOperation]: any = useState("add");
  const toaster = useToast();
  const ApiService = useApiService();
  const loader: any = useLoader();
  const configFormDetails: any = useRef();
  const [step, updateStep] = useState(1);
  const dialCode: any = useRef<any>();
  const countryCode: any = useRef();
  const [id, setId]: any = useState();
  const [defaultCapacity, setDefaultCapacity]: any = useState();
  const [appData]: any = useAppContext();
  const [configData, setConfigData]: any = useState();
  const { register, handleSubmit, reset, errors } = useForm();
  const obj = {
    unit: {
      required: ValidationService.requiredValidator(),
    },
    defaultCapacity: {
      required: ValidationService.requiredValidator(),
    },
  };
  const fetchDialCode = (dialcode: any, countrycode: any) => {
    dialCode.current = "+" + dialcode;
    countryCode.current = countrycode.toUpperCase();
  };
  const classes = useStyles();
  useImperativeHandle(ref, () => ({
    handleOpen(operation?: any) {
      updateStep(1);

      if (operation === 1) {
        setOperation("edit");
        if (props.config) {
          resetConfigData(props.config);
          setConfigData(props.config);
        }
        setOpen(true);
      } else {
        resetForm();
        setOperation("add");
        setOpen(true);
      }
    },
  }));
  const resetForm = () => {
    reset({
      phone: "",
    });
  };
  const onConfirm = () => {
    submitCapacityManagementData(configFormDetails.current.value);
  };
  const resetConfigData = (data: any) => {
    // countryCode.current = data.country_code,
    setId(data.id);
    reset({
      phone: data.phone,
    });
  };
  const openConfirmation = (data: any) => {
    let updateValue: any = false;
    if (props.config.country_code != dialCode.current) {
      updateValue = true;
    }
    if (data.phone != configData.phone) {
      updateValue = true;
    }
    if (!updateValue) {
      toaster.addToast({
        message: "Please update a value",
        timeout: 3000,
        type: "error",
      });
      return;
    }
    configFormDetails.current.value = data;
    updateStep(2);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const submitCapacityManagementData = (data: any) => {
    if (!data?.phone.trim()) {
      toaster.addToast({
        message: t("Team:Please enter Phone Number"),
        timeout: 3000,
        type: "error",
      });
      return;
    }

    let sosConfigData: any = {};
    const headers = {
      access_token: appData.loginData.access_token,
    };
    if (operation != "edit") {
      sosConfigData = {
        country_code: dialCode.current,
        phone: Number(data.phone),
        price: Number(extensionPrice),
      };
    } else {
      sosConfigData = {
        id: id,
        country_code: dialCode.current,
        phone: Number(data.phone),
      };
    }

    const reqData = {
      reqBody: sosConfigData,
      headers: headers,
    };

    loader.showLoader();
    return ApiService[operation === "edit" ? "put" : "post"](
      extensionService.sosSubscription(reqData, operation === "edit" ? 1 : 0)
    )
      .then((res: any) => {
        loader.hideLoader();
        toaster.addToast({
          message: res.message,
          timeout: 3000,
          type: "success",
        });
        handleClose();
        props.handleSosSubscription();
        props.fetchCapacityDetail(true);
      })
      .catch((err: any) => {
        loader.hideLoader();
        toaster.addToast({
          message: err.message,
          timeout: 3000,
          type: "error",
        });
      });
  };
  return (
    <Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        className={classes.modal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper} ref={configFormDetails}>
            {step === 1 ? (
              <form
                onSubmit={handleSubmit(
                  operation === "edit"
                    ? openConfirmation
                    : submitCapacityManagementData
                )}
              >
                <h2 id="modal-title">
                  {(operation != "edit" ? "Add " : "Edit ") + "Details"}
                </h2>
                <Phone
                  hideLabel={true}
                  showPhone={true}
                  setDialCode={(dialcode: any, countrycode: any) => {
                    fetchDialCode(dialcode, countrycode);
                  }}
                  name={`phone`}
                  id={`phone`}
                  label={"Mobile Number"}
                  placeholder={t("Common:Enter Mobile Number") + "*"}
                  defaultPhone={
                    props.config?.country_code
                      ? props.config.country_code
                      : "+91"
                  }
                  //   phoneNumber={
                  //     taskType === 0
                  //       ? pickupFields[index]["phone"]
                  //       : deliveryFields[index]["phone"]
                  //   }
                  errors={errors}
                  refValue={register(
                    // {
                    //   validate: (value: any) => {
                    //     if (!value) {
                    //       openAccordion("accordion" + index + taskType);
                    //       const errMsg: any = t(
                    //         "Validation:This field is required."
                    //       );
                    //       return errMsg;
                    //     } else {
                    //       return true;
                    //     }
                    //   },
                    // }
                    obj.unit
                  )}
                ></Phone>
                <div>
                  <Btn
                    className={classes.btn}
                    type={"Submit"}
                    // onClick={onConfirm}
                    btnText={t("Common:Submit")}
                  >
                    {" "}
                  </Btn>
                  <Btn
                    onClick={() => {
                      setOpen(false);
                    }}
                    color={"default"}
                    type={"button"}
                    btnText={t("Common:Cancel")}
                  >
                    {" "}
                  </Btn>
                </div>
              </form>
            ) : (
              <div>
                <h2 id="modal-title">{t("Extension:Update Configuration")}</h2>
                <p style={{ textAlign: "left" }}>
                  {" "}
                  {t(
                    "Extension:If you update the configuration Settings, Sos phone number will update . Do you still want to continue?"
                  )}
                </p>
                <div>
                  <Btn
                    className={classes.btn}
                    type={"button"}
                    onClick={onConfirm}
                    btnText={t("Common:Confirm")}
                  >
                    {" "}
                  </Btn>
                  <Btn
                    onClick={handleClose}
                    color={"default"}
                    type={"button"}
                    btnText={t("Common:Discard")}
                  >
                    {" "}
                  </Btn>
                </div>
              </div>
            )}
          </div>
        </Fade>
      </Modal>
    </Fragment>
  );
});

export default SosConfiguration;
